
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sdks",
      function () {
        return require("private-next-pages/sdks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sdks"])
      });
    }
  